import {initPreviews} from './init'

initPreviews()
